import type { IComponentProps } from './index';

/**
 * Undefined means "not configured", which keeps the original behaviour —
 * screens built before these settings existed carry neither.
 */
export const toEpiProps = (componentProps: IComponentProps) => ({
  instance: componentProps.epiInstance,
  canAddProduct: componentProps.canAddProduct !== false,
  canRemoveProduct: componentProps.canRemoveProduct !== false,
  canManageDocuments: componentProps.canManageDocuments !== false,
  canRenameDocuments: componentProps.canRenameDocuments !== false,
  canAddCustomSections: componentProps.canAddCustomSections !== false,
  canExport: componentProps.canExport !== false,
  canImport: componentProps.canImport === true,
  defaultLanguage: componentProps.defaultLanguage,
  readOnly: componentProps.readOnly === true,
});
